<div>
  <form [formGroup]="validateDocumentAccessForm" *ngIf="validateDocumentAccessData.isValid">
    <div *ngIf="!validateDocumentAccessData.esignCompleted" class="insured-esign-container">
      <div class="insured-esign-card">
        <section class="insured-esign-card__content">
          <header class="insured-esign-card__header">
            <h1 class="insured-esign-card__heading">
              Verify {{ validateDocumentAccessData.signerFirstName }}'s identity to continue
            </h1>
            <div class="insured-esign-card__divider"></div>
          </header>
          <div class="insured-esign-card__body">
            <p class="insured-esign-card__body-text">
              Enter the last four digits of {{ validateDocumentAccessData.signerFirstName }}'s Social Security Number.
            </p>
            <div class="insured-esign-card__enter-ssn">
              <cp-label>### - ## -</cp-label>
              <input
                formControlName="SSN"
                placeholder="####"
                class="form-field__input cp-box__input insured-esign-card__last-four"
                [ngClass]="{ 'cp-box__input--error': validateDocumentAccessForm.get('attemptsRemaining').invalid }"
              />
            </div>
            <div>
              <cp-error *ngIf="validateDocumentAccessForm.get('attemptsRemaining').invalid">
                <span *ngIf="validateDocumentAccessForm.get('attemptsRemaining').value !== 0">
                  Invalid last 4 digits, you have
                  {{ validateDocumentAccessForm.get('attemptsRemaining').errors.max }} attempts remaining
                </span>
                <span *ngIf="validateDocumentAccessForm.get('attemptsRemaining').value === 0">
                  Too many attempts, please contact
                  <a href="mailto:DigitalCustomerSupport@massmutual.com">DigitalCustomerSupport@massmutual.com</a>
                </span>
              </cp-error>
            </div>
          </div>
          <div class="button-container">
            <button
              class="button button--blue button--primary"
              [disabled]="validateDocumentAccessForm.get('attemptsRemaining').value == 0"
              (click)="validateSSN()"
            >
              Submit
            </button>
          </div>
        </section>
      </div>
    </div>
  </form>

  <div *ngIf="validateDocumentAccessData.esignCompleted" class="insured-esign-finished">
    <div class="header">Congratulations, you're covered!</div>
    <div class="sub-header">Your policy is active.</div>
  </div>

  <div *ngIf="!validateDocumentAccessData.isValid" class="insured-esign-finished">
    <div class="header">An error has occurred.</div>
    <div class="sub-header">
      Please contact
      <a href="mailto:DigitalCustomerSupport@massmutual.com">DigitalCustomerSupport@massmutual.com</a>
      .
    </div>
  </div>

  <div *ngIf="validateDocumentAccessData.urlExpired" class="insured-esign-finished">
    <div class="header">This link is expired.</div>
  </div>
</div>

<loading *ngIf="loadingScreen"></loading>
